import { render, staticRenderFns } from "./Counselors.vue?vue&type=template&id=8a957638&scoped=true"
import script from "./Counselors.vue?vue&type=script&lang=js"
export * from "./Counselors.vue?vue&type=script&lang=js"
import style0 from "./Counselors.vue?vue&type=style&index=0&id=8a957638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a957638",
  null
  
)

export default component.exports